import { CheckListWrapper } from 'components/calendar/filters/style';
import useClickOutsideHook from 'hooks/clickOutsideHook';
import { IProvider } from 'model/v2';
import React, {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useRef,
  useState
} from 'react';
import { Input, InputOnChangeData } from 'semantic-ui-react';
import ProviderItems from './ProviderItems';
import { ProviderCheckListSSWrapper } from './style';

interface IProps {
  allProviders: IProvider[];
  selectedProvidersList: Set<number>;
  setSelectedProvidersList: Dispatch<SetStateAction<Set<number>>>;
}
const ProviderSelectorSS: React.FC<IProps> = ({
  allProviders,
  selectedProvidersList,
  setSelectedProvidersList
}: IProps) => {
  const [isVisibleList, setIsVisibleList] = useState(false);
  const [checkedItems, setCheckedItems] = useState(new Set<number>());
  const [searchResults, setSearchResults] = useState<IProvider[]>(allProviders);

  const filtersRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    setSearchResults(allProviders);
  }, [allProviders]);

  const closeFiltersList = useCallback(() => {
    setIsVisibleList(false);
  }, [setIsVisibleList]);

  useClickOutsideHook(filtersRef, closeFiltersList);

  const toggleList = useCallback(() => {
    setIsVisibleList(prev => !prev);
  }, [setIsVisibleList]);

  const handleSearch = (
    _e: React.ChangeEvent<HTMLInputElement>,
    data: InputOnChangeData
  ) => {
    setIsVisibleList(true);
    setSearchResults(
      allProviders.filter(it =>
        [it.displayName, it.name].some(name =>
          name?.toLocaleLowerCase()?.startsWith(data.value.toLocaleLowerCase())
        )
      )
    );
  };

  const onHandleCheckChange = (id: number, isChecked?: boolean) => {
    if (isChecked) {
      setCheckedItems(prev => new Set(prev).add(id));
    } else {
      setCheckedItems(prev => {
        const next = new Set(prev);
        next.delete(id);
        return next;
      });
    }
  };

  const onClearAll = useCallback(() => {
    setCheckedItems(new Set());
  }, [setCheckedItems]);

  const onApply = useCallback(() => {
    setSelectedProvidersList(new Set(checkedItems));
    setIsVisibleList(false);
  }, [setSelectedProvidersList, setIsVisibleList, checkedItems]);

  useEffect(() => {
    setCheckedItems(new Set(selectedProvidersList));
  }, [selectedProvidersList]);

  return (
    <ProviderCheckListSSWrapper>
      <CheckListWrapper visible={isVisibleList} height={'162px'}>
        <div ref={filtersRef}>
          <div className="filter-input_wrapper" onClick={toggleList}>
            <Input
              className="filter_input"
              placeholder="Search Providers"
              onChange={handleSearch}
            />
          </div>
          {isVisibleList && (
            <div className="list_wrapper filter_list">
              <div className="scrollable_list">
                {searchResults.length === 0 && (
                  <p className="no-results_filter">No results found</p>
                )}
                <ProviderItems
                  providers={searchResults}
                  checkedItems={checkedItems}
                  onHandleChange={onHandleCheckChange}
                />
              </div>
              <div className="calender-filters_actions">
                <span onClick={onClearAll}>Clear all</span>
                <button
                  onClick={onApply}
                  disabled={false}
                  className={checkedItems.size > 0 ? 'highlightButton' : ''}
                >
                  Apply
                </button>
              </div>
            </div>
          )}
        </div>
      </CheckListWrapper>
    </ProviderCheckListSSWrapper>
  );
};
export default React.memo(ProviderSelectorSS);
